import type { Ref } from "react";
import { forwardRef } from "react";
import cx from "ui/cx";
import styles from "./FullScreenBox.module.scss";

const FullScreenBox = forwardRef(function fullScreenBox(
  { children, className }: React.HTMLProps<HTMLDivElement>,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <div ref={ref} className={cx(styles.wrapper, className)}>
      {children}
    </div>
  );
});

export default FullScreenBox;
